import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["siret", "form", "loading", "result", "error"]
  static values = { 
    customerId: Number,
    updateUrl: String 
  }

  connect() {
    console.log("Sirene controller connected")
  }

  // Récupère les données SIRENE pour un SIRET
  async fetchSireneData(event) {
    event.preventDefault()
    
    const siret = this.siretTarget.value.trim()
    if (!siret || siret.length !== 14) {
      this.showError("Le SIRET doit contenir exactement 14 chiffres")
      return
    }

    this.showLoading(true)
    this.hideError()
    this.hideResult()

    try {
      const response = await fetch(`/api/sirene/${siret}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        this.fillFormWithSireneData(data.data)
        this.showResult("Données SIRENE récupérées avec succès")
      } else {
        this.showError(data.error || "Erreur lors de la récupération des données")
      }
    } catch (error) {
      console.error("Erreur API SIRENE:", error)
      this.showError("Erreur de connexion au service SIRENE")
    } finally {
      this.showLoading(false)
    }
  }

  // Met à jour un customer avec les données SIRENE
  async updateCustomer(event) {
    event.preventDefault()
    
    if (!this.hasCustomerIdValue) {
      this.showError("ID du client manquant")
      return
    }

    this.showLoading(true)
    this.hideError()
    this.hideResult()

    try {
      const response = await fetch(`/api/sirene/update_customer/${this.customerIdValue}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        this.showResult(data.message)
        // Optionnel : recharger la page ou mettre à jour l'interface
        if (data.customer) {
          this.updateCustomerDisplay(data.customer)
        }
      } else {
        this.showError(data.error || "Erreur lors de la mise à jour")
      }
    } catch (error) {
      console.error("Erreur mise à jour client:", error)
      this.showError("Erreur de connexion")
    } finally {
      this.showLoading(false)
    }
  }

  // Remplit le formulaire avec les données SIRENE
  fillFormWithSireneData(data) {
    const form = this.formTarget
    
    // Mapping des champs
    const fieldMapping = {
      'name': data.denomination,
      'trancheEffectifsEtablissement': data.trancheEffectifsEtablissement,
      'dateCreationEtablissement': data.dateCreationEtablissement,
      'adresse1': data.adresse1,
      'adresse2': data.adresse2,
      'ville': data.ville,
      'code_postal': data.code_postal,
      'pays': data.pays,
      'nom_contact': data.nom_contact,
      'prenom_contact': data.prenom_contact,
      'activite': data.activite,
      'opco': data.opco
    }

    Object.entries(fieldMapping).forEach(([fieldName, value]) => {
      const field = form.querySelector(`[name*="${fieldName}"]`)
      if (field && value) {
        field.value = value
        // Déclenche l'événement input pour mettre à jour le compteur
        field.dispatchEvent(new Event('input', { bubbles: true }))
      }
    })
  }

  // Met à jour l'affichage du client
  updateCustomerDisplay(customerData) {
    // Ici vous pouvez mettre à jour l'interface utilisateur
    // Par exemple, mettre à jour des éléments HTML avec les nouvelles données
    console.log("Client mis à jour:", customerData)
  }

  // Utilitaires d'affichage
  showLoading(show) {
    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = show ? 'block' : 'none'
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.style.display = 'block'
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.style.display = 'none'
    }
  }

  showResult(message) {
    if (this.hasResultTarget) {
      this.resultTarget.textContent = message
      this.resultTarget.style.display = 'block'
    }
  }

  hideResult() {
    if (this.hasResultTarget) {
      this.resultTarget.style.display = 'none'
    }
  }
} 